import { TableCell, TableRow } from "./ui/table";

type TableBodyRowEmptyProps = {
  columns: number;
  message?: string;
};

/** Full-width body row for empty, loading, and error table states. */
export function TableBodyRowEmpty({ columns, message = "Sem dados" }: TableBodyRowEmptyProps) {
  return (
    <TableRow className="hover:bg-transparent">
      <TableCell className="text-muted-foreground py-6 text-center" colSpan={columns}>
        {message}
      </TableCell>
    </TableRow>
  );
}
